import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useClientSelection } from '../stores/clientSelection'
import type { ClientDto } from '@emag/shared'

/** Dropdown global de selecție client (tenant). Sursă unică pentru paginile de browsing. */
export function ClientSelect() {
  const selectedClientId = useClientSelection((s) => s.selectedClientId)
  const setSelectedClientId = useClientSelection((s) => s.setSelectedClientId)

  const { data } = useQuery({
    queryKey: ['clients'],
    queryFn: async () => (await api.get<{ clients: ClientDto[] }>('/clients')).data.clients,
  })
  const clients = data ?? []

  // Auto-selectează primul client dacă niciunul nu e ales.
  useEffect(() => {
    if (selectedClientId == null && clients.length > 0) {
      setSelectedClientId(clients[0].id)
    }
  }, [selectedClientId, clients, setSelectedClientId])

  return (
    <select
      value={selectedClientId ?? ''}
      onChange={(e) => setSelectedClientId(e.target.value ? Number(e.target.value) : null)}
      className="rounded-md border border-b4l-border bg-white px-3 py-1.5 text-[13px] outline-none focus:border-b4l-green"
    >
      {clients.length === 0 && <option value="">— niciun client —</option>}
      {clients.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>
  )
}
